import { render, staticRenderFns } from "./ProfileDeactivate.vue?vue&type=template&id=1bc385b6&"
import script from "./ProfileDeactivate.vue?vue&type=script&lang=js&"
export * from "./ProfileDeactivate.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDeactivate.vue?vue&type=style&index=0&id=1bc385b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports